import { getData, postData } from '@/utils/http'
import config from '@/config';
export default {
	namespaced: true,
	state: {
		dataLoading: true,
		addLoading: false,
		statisticsData: {},
		echartsData: {},

		//查询条件
		year: new Date().getFullYear(),
		month: new Date().getMonth() + 1,
		deptId: "",
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, dataLoading) {
			state.dataLoading = dataLoading
		},

		CHANGE_STATISTICS_DATA(state, changeData) {
			state.statisticsData = changeData.data
		},
		CHANGE_ECHARTS_DATA(state, changeData) {
			state.echartsData = changeData.data
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
				state[changeData['changeKey']] = [changeData['data']]
			} else {
				state[changeData['changeKey']] = changeData['data']
			}
		}
	},
	actions: {
		//获取首页统计数据
		getStatisticsData({ commit, state },deptId) {
			return new Promise(resolve => {
				
				const queryParams = config.jsonToQueryParams({
					year: state.year,
					month: state.month,
					deptId:deptId
				});
				getData(`logistics/index/vo?${queryParams}`).then(res => {
					if (res.state == 1) {
						commit('CHANGE_STATISTICS_DATA', res)
						resolve({
							state: 1,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
						commit('CHANGE_STATISTICS_DATA', {
							data:{

							}
						})
					}
				})
			})
		},
		//获取首页图表数据
		getEchartsData({ commit, state },deptId) {
			const query = {
				year: state.year,
				month: state.month,
				deptId: deptId
			}
			return new Promise(resolve => {
				getData(`logistics/index/month/data`, query).then(res => {
					if (res.state == 1) {
						if(!res.data['orderData']){
							commit('CHANGE_ECHARTS_DATA', {
								data:null
							})
						}else{
							commit('CHANGE_ECHARTS_DATA', res)
							resolve({
								state: 1,
								msg: '操作成功'
							})
						}
						
					} else {
						commit('CHANGE_ECHARTS_DATA', {
							data:null
						})
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},


		//修改添加loading
		changeListLoading({ commit }, value) {
			commit('CHANGE_TABLE_LOADING', value)
		},
		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit('CHANGE_SEARCH_COLL', changeData)
		}
	}
}